export default "__VITE_ASSET__CmX6$SeB__"